<template>
  <footer class="g-jpca-footer">
    <div class="g-jpca-footer__logos">
      <GuiLink
        :aria-label="gettyImageAlt"
        target="_blank"
        href="https://www.getty.edu"
      >
        <Logo />
      </GuiLink>
      <GuiLink :aria-label="jpcImageAlt" :to="{ name: 'home' }">
        <JPCALogo variation="redOnLight" />
      </GuiLink>
      <GuiLink
        :aria-label="nmaahcImageAlt"
        target="_blank"
        href="https://nmaahc.si.edu"
      >
        <NMAAHCLogo class="g-jpca-footer__nmaahc-logo" />
      </GuiLink>
    </div>
    <div class="g-jpca-footer__links">
      <div class="g-jpca-footer__links-part">
        <p class="g-jpca-footer__copyright-text">
          {{ copyrightText }}
        </p>
      </div>
      <div class="g-jpca-footer__links-part">
        <ListOfLinks :links="links" />
      </div>
    </div>
  </footer>
</template>
<script>
import JPCALogo from "@/components/atoms/jpcaLogo/index.vue";
import NMAAHCLogo from "@/components/atoms/nmaahcLogo/index.vue";
import {
  GuiLink,
  ListOfLinks,
  Logo,
  useLocalization
} from "@thegetty-private/getty-ui";
export default {
  name: "JPCAFooter",
  components: {
    JPCALogo,
    NMAAHCLogo,
    GuiLink,
    Logo,
    ListOfLinks
  },

  props: {
    /**
     * the footer links
     */
    links: {
      type: Array,
      required: false,
      default: () => []
    }
  },
  setup(props) {
    return {
      ...useLocalization({
        baseLocaleKey: props?.baseLocaleKey
      })
    };
  },

  data() {
    return {
      /**
       * the alt text for the NMAAHC image
       */
      nmaahcImageAlt: this.translatePart("g-jpca-footer.nmaahc_image_alt"),
      /**
       * the alt text for the Getty image
       */
      gettyImageAlt: this.translatePart("g-jpca-footer.getty_image_alt"),
      /**
       * the alt text for the JPC image
       */
      jpcImageAlt: this.translatePart("g-jpca-footer.jpc_image_alt"),
      /**
       * the copyright text
       */
      copyrightText: this.translatePart("g-jpca-footer.copyright_text")
    };
  }
};
</script>
<style lang="scss">
@import "./index.scss";
</style>
